import { TextBody } from '@tkww/orion-web-ds-text';
import React, { type FC, type ReactNode } from 'react';
import Styles from './styles.scss';

interface BannerInfoProps {
	label?: string;
	info?: string;
	className?: string;
	children?: ReactNode;
}

export const BannerInfo: FC<BannerInfoProps> = ({
	label,
	info,
	className = '',
	children,
}) => {
	return (
		<div className={`${Styles.bannerInfoContainer} ${className}`}>
			<div className={Styles.bannerInfoContent}>
				{children ? (
					children
				) : (
					<>
						{label && (
							<TextBody size="sm" bold className={Styles.labelText}>
								{label}
							</TextBody>
						)}
						{info && (
							<TextBody size="sm" className={Styles.infoText}>
								{info}
							</TextBody>
						)}
					</>
				)}
			</div>
		</div>
	);
};
